import { render, staticRenderFns } from "./IncentiveContact.vue?vue&type=template&id=c2258b2c&scoped=true"
import script from "./IncentiveContact.vue?vue&type=script&lang=js"
export * from "./IncentiveContact.vue?vue&type=script&lang=js"
import style0 from "./IncentiveContact.vue?vue&type=style&index=0&id=c2258b2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2258b2c",
  null
  
)

export default component.exports